// extracted by mini-css-extract-plugin
export default {"storySection":"Story_storySection__VacGJ","statistics":"Story_statistics__gy+QY","statisticBlock":"Story_statisticBlock__LxzLR","fadeIn":"Story_fadeIn__Pc3So"};